import React, {useState, useEffect,useRef} from 'react';
import { connect } from 'react-redux';
import Head from '../../components/head/Head'
import Foot from '../../components/foot/Foot'
import { Input, message,Statistic,Progress,Modal  } from 'antd';
import {balanceOf,signer, transfer} from '../../utils/ethers'
import md5 from 'js-md5';
import NumberFormat from 'react-number-format'
import contractAddress from "../../utils/contractAddress.json"
import Moment from 'react-moment'
import {useNavigate} from "react-router-dom";
import { useTranslation } from 'react-i18next'
import {
    WarningOutlined,CloseOutlined,ExclamationCircleOutlined 
  } from '@ant-design/icons';

import '../invite/index.less'
import './game.css'
import {addPet1, getGameIndex160,rePet1} from "../../api";
import CountUp from "react-countup";
import { CSSTransition } from 'react-transition-group';
import { useWebSocket } from "../../components/ws/ws.tsx";
const { Countdown } = Statistic;
const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        chain:state.chain
    }
}

const Game160 = (props) => {
    const { status, messages, sendMessage,qu } = useWebSocket( "60","2");
    const navigate = useNavigate()
    
    const scrollContainerRef = useRef(null);
    const { t } = useTranslation()
    const [num,setNum] = useState(0)
    const [showRecord,setShowRecord] = useState(false)
    
    const [sec,setSec] = useState(60)
   
    const ref = useRef(null)

    const [preBlock,setPreBlock] = useState("")
    const [nextBlock,setNextBlock] = useState("")

    const [min1,setMin1] = useState(1)
    const [min2,setMin2] = useState(1)
    const [min3,setMin3] = useState(1)
    const [min4,setMin4] = useState(1)

    const [odds,setOdds] = useState(1.95)

    const [feg_n,setFegN] = useState(0)
    const [usdt_n,setUsdtN] =useState(0)
    const [fegw_n,setFegwN] =useState(0)
    const [udt_n,setUdtN] =useState(0)

    const [coin,setCoin] = useState("feg")

    const [petting,setPetting] = useState(1)

    const [list,setList] = useState([])
    const [list1,setList1] = useState([])
    const [info,setInfo] = useState({
        "hash":""
    })

    const [needValue,setNeedValue] = useState("")


    const [needUsdt,setNeedUsdt] = useState("")
    const [needToken,setNeedToken] = useState("")
    
    const [fegPrice,setFegPrice] = useState(0)
    const [days,setDays] =useState(30)

    
    const [isLock,setIsLock]=useState(false)

    const _showRecord = (e) =>{
        setInfo(e)
        setShowRecord(true)
    }

  

    const open = () => {
        if(props.address.length<=0 ){
                        message.error(t('head.请先连接钱包'))
                        return false
                    }
               
        let _bal
        if(coin =="feg"){
            _bal = feg_n
        }else if(coin == "fegw"){
            _bal = fegw_n
        }else if(coin == "usdt"){
            _bal = usdt_n
        }else if(coin == "udt"){
            _bal = udt_n
        }

        Modal.confirm({
            
            title:  + petting ==1?t('game1.阳能'):t('game1.暗流') ,
            icon: <ExclamationCircleOutlined />,
             //content: t('game1.当前')+coin+t('game1.投注余额')+":"+coin=="feg"?feg_n:coin=="fegw"?fegw_n:coin=="usdt"?usdt_n:udt_n+","+t('game1.确认下注')+":"+petting+"?",
             content: t('game1.当前')+" "+coin+" "+t('game1.投注余额')+"："+_bal+"，"+t('game1.确认下注')+"："+needValue+"?",
            okText: t('game1.确认'),
            cancelText: t('game1.取消'),
            centered:true,
            onOk(){
                _rand()
            }
        });
    };


    const _getIndex1= () =>{
        if(props.address.length === 0 || props.isLogin === false){
            return false
        }
        getGameIndex160().then(res=>{
            if(res.code === 0 ){
                             
   
           
                setFegN(res.data.feg_n)
                setFegwN(res.data.fegw_n)
                setUdtN(res.data.udt_n)
                setUsdtN(res.data.usdt_n)
              
                setPreBlock(res.data.pre_block)
                setNextBlock(res.data.next_block)
                if(res.data.list != null){
                    setList(res.data.list)
                }
        

         
                    

            }else{
                message.error(res.msg)
            }
        },error =>{
            message.error(error)
        })

    }


    const _getIndex= () =>{
        if(props.address.length === 0 || props.isLogin === false){
            return false
        }
        getGameIndex160().then(res=>{
            if(res.code === 0 ){
                             
   
                setMin1(res.data.min1)
                setMin2(res.data.min2)
                setMin3(res.data.min3)
                setMin4(res.data.min4)
                setFegN(res.data.feg_n)
                setFegwN(res.data.fegw_n)
                setUdtN(res.data.udt_n)
                setUsdtN(res.data.usdt_n)
                setOdds(res.data.odds)
                setPreBlock(res.data.pre_block)
                setNextBlock(res.data.next_block)
                if(res.data.list != null){
                    setList(res.data.list)
                }
                setSec(res.data.sec)
                let _now = res.data.sec-1
                
                const timer = setInterval(()=>{
                    // console.log(_now)
                    if(_now <=0){
                       
                        _now = 60
                        setPreBlock(preBlock=>preBlock+20)
                     setNextBlock(nextBlock=>nextBlock+20)
                     
                    }else if(_now == 57){
scrollContainerRef.current.scrollLeft = scrollContainerRef.current.scrollWidth;

                    }else if(_now == 55){
                        _getIndex1()
                    }
                    
                   setSec(()=>_now);
                   _now=_now-1
                  
                //    if(sec==30){
                //     setPreBlock(preBlock=>preBlock+10)
                //     setNextBlock(nextBlock=>nextBlock+10)
                //    }
                },1000)
                ref.current = timer

         
                    

            }else{
                message.error(res.msg)
            }
        },error =>{
            message.error(error)
        })

    }









    
    const _rand= () =>{
        // if (coin != "udt"){
        //      message.error(t('g.改币种未开放，请使用体验金'))
        //                 return
        // }
    
        // if(props.address.length<=0) return false
        if(props.address.length<=0){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            message.error(t('head.您还未绑定钱包，请绑定激活钱包地址'))
            return false
        }

           if(!needValue){
            message.error(t('game1.请输入投注数量'))
            return false
        }
        if(needValue.length<=0){
            message.error(t('game1.请输入投注数量'))
            return false
        }

        // if(needValue>3000){
        //      message.error(t('game1.不能超出最大投注数'))
        //     return false
        // }

        if (coin == "feg"){
            if(parseFloat(needValue)>1000000){
                message.error(t('game1.不能超出最大投注数')+":1000000")
                return false
            }
            if(parseFloat(needValue)<parseFloat(min1)){
                message.error(t('game1.最小投注')+":"+min1)
                return false
            }

            if(parseFloat(needValue) > parseFloat(feg_n)){
                 message.error(t('game1.余额不足')+":"+coin)
                return false
            }
        }else if (coin == "fegw"){
                  message.error(t('g.改币种未开放'))
                        return
            if(parseFloat(needValue)>200){
                message.error(t('game1.不能超出最大投注数')+":200")
                return false
            }
            if(parseFloat(needValue)<parseFloat(min2)){
                message.error(t('game1.最小投注')+":"+min2)
                return false
            }

            if(parseFloat(needValue) > parseFloat(fegw_n)){
                 message.error(t('game1.余额不足')+":"+coin)
                return false
            }
        }else if (coin == "usdt"){
            message.error(t('g.改币种未开放'))
                        return
            if(parseFloat(needValue)>200){
                message.error(t('game1.不能超出最大投注数')+":200")
                return false
            }
            if(parseFloat(needValue)<parseFloat(min3)){
                message.error(t('game1.最小投注')+":"+min3)
                return false
            }

            if(parseFloat(needValue) > parseFloat(usdt_n)){
                 message.error(t('game1.余额不足')+":"+coin)
                return false
            }
        }else if (coin == "udt"){
            if(parseFloat(needValue)>200){
                message.error(t('game1.不能超出最大投注数')+":200")
                return false
            }
            if(parseFloat(needValue)<parseFloat(min4)){
                message.error(t('game1.最小投注')+":"+min4)
                return false
            }

            if(parseFloat(needValue) > parseFloat(udt_n)){
                 message.error(t('game1.余额不足')+":"+coin)
                return false
            }
        }


        if(isLock) return false;
        setIsLock(true)
                  addPet1({address:props.address,value:parseFloat(needValue),coin:String(coin),petting:String(petting),game:"2",sec:String(60)}).then(res=>{
                if(res.code===0){
                    message.success(res.msg)
                }else{
                    message.error(res.msg)
                }
                  setIsLock(false)
                setNum(num+1)
            },error=>{
                setIsLock(false)
                message.error(error)
            })
        // signer(props.address).then(res1=>{
        //                addPet1({address:props.address,pass:md5(res1).pass,value:parseFloat(needValue),coin:String(coin),petting:String(petting),game:"2",sec:String(60)}).then(res=>{
        //         if(res.code===0){
        //             message.success(res.msg)
        //         }else{
        //             message.error(res.msg)
        //         }
        //           setIsLock(false)
        //         setNum(num+1)
        //     },error=>{
        //         setIsLock(false)
        //         message.error(error)
        //     })
                    
        //            },error=>{
        //                setIsLock(false)
        //                message.error(error)
        //            })
       
            

       



    }



    const goTron = (e) =>{
        if(e.length==0){
            return
        }
         window.open('https://tronscan.org/#/block/'+e, '_blank');
    }

    const getQu =() =>{
        
        if(messages==null){
            return
        }
        if(messages.history.length>0){
            let first =messages.history[0].petting_res2

        }
        let str = "<div className='w-4 mr-2'>"
        let index =0
        let useCol =0
            for(let i=0;i<=messages.history.length;i++){
                if(index==messages.history.length){
                    break
                }
                if(index==0){
                    if(messages.history[0].petting_res2 ==1){
                        str +="<div className='w-4 h-4  bg-red-500 mt-2 text-xs'></div>"
                    }else if(messages.history[0].petting_res2 ==2)(
                        str +="<div className='w-4 h-4  bg-gray-500 mt-2 text-xs'></div>"
                    )
                    index++
                    useCol++
                }
                if(index>0){
                    if(messages.history[index].petting_res2 == messages.history[index-1].petting_res2){
                         if(useCol<5){
                            if(messages.history[index].petting_res2 ==1){
                                str +="<div className='w-4 h-4  bg-red-500 mt-2 text-xs'></div>"
                            }else if(messages.history[index].petting_res2 ==2)(
                                str +="<div className='w-4 h-4  bg-gray-500 mt-2 text-xs'></div>"
                            )
                            index++
                            useCol++
                         }else if(useCol==5){
                            str +="</div>"
                            str +="<div className='w-4 mr-2'>"
                            if(messages.history[index].petting_res2 ==1){
                                str +="<div className='w-4 h-4  bg-red-500 mt-2 text-xs'></div>"
                            }else if(messages.history[index].petting_res2 ==2)(
                                str +="<div className='w-4 h-4  bg-gray-500 mt-2 text-xs'></div>"
                            )
                            index++
                            useCol = 1
                         }
                         
                    }else{
                        for(let y=0;y<(5-useCol);y++){
                             str +="<div className='w-4 h-4  mt-2 text-xs'></div>"
                        }
                        str +="</div>"
                        str +="<div className='w-4 mr-2'>"
                        if(messages.history[index].petting_res2 ==1){
                            str +="<div className='w-4 h-4  bg-red-500 mt-2 text-xs'></div>"
                            }else if(messages.history[index].petting_res2 ==2)(
                                str +="<div className='w-4 h-4  bg-gray-500 mt-2 text-xs'></div>"
                            )
                        index++
                        useCol = 1
                    }
                }
            }
            for(let y=0;y<(5-useCol);y++){
                    str +="<div className='w-4 h-4  mt-2 text-xs'></div>"
            }
            str +="</div>"
console.log(str)
            return str
            // <div className='w-4 mr-2'>
            //                     <div className='w-4 h-4  bg-gray-500 mt-2 text-xs'></div>
            //                     <div className='w-4 h-4  bg-gray-500 mt-2 text-xs'></div>
            //                     <div className='w-4 h-4  bg-gray-500 mt-2 text-xs'></div>
            //                     <div className='w-4 h-4  bg-gray-500 mt-2 text-xs'></div>
            //                     <div className='w-4 h-4  bg-gray-500 mt-2 text-xs'></div>
            //             </div>
        
        
    }

      const hui =(id,state) =>{
       console.log(id)
       console.log(state)
       if(props.address.length<=0){
               message.error(t('head.请先连接钱包'))
               return false
           }
           if(props.isLogin === false){
               message.error(t('head.您还未绑定钱包，请绑定激活钱包地址'))
               return false
           }
           if(isLock) return false;
           setIsLock(true)
           rePet1({address:props.address,id:String(id)}).then(res=>{
                   if(res.code===0){
                       message.success(res.msg)
                   }else{
                       message.error(res.msg)
                   }
                     setIsLock(false)
                     setShowRecord(false)
                   setNum(num+1)
               },error=>{
                   setIsLock(false)
                   message.error(error)
               })
   
      }

    useEffect(() => {
             window.scrollTo(0, 0)
           
        if(scrollContainerRef.current){
            scrollContainerRef.current.scrollLeft = scrollContainerRef.current.scrollWidth;
        }
                        
                    
            switch(status){
                case "connecting":
                clearInterval(ref.current);
                break;
                case "open":
                _getIndex();
                break;
                case "closed":
               clearInterval(ref.current)
  
                navigate("/game")
                break;
            }
         
          
             
            
            return ()=>{
                clearInterval(ref.current)
            };
          
          
    }, 
    // eslint-disable-next-line
    [props.isLogin,num,status,message.hash]);

    const clearTimer = () =>{
        clearInterval(ref.current)
    }

    return (
        <>
    
            <Head/>
            <CSSTransition
                        in={sec<4}
                        unmountOnExit={true}
                        classNames='record'
                        timeout={500}
                        appear
                        >
                        <div className=' w-full lg:w-1/3 h-screen  fixed left-0 top-0  bg-black bg-opacity-80 inout1  flex flex-row justify-center items-center'>
                                    <span className=' text-white -mt-32'>{t('game1.封盘中')}..</span>
                        </div>
                        </CSSTransition>
        
            <CSSTransition
                        in={showRecord}
                        unmountOnExit={true}
                        classNames='record'
                        timeout={500}
                        appear
                        onEnter={(e) => console.log('开始进入动画')}
                        onEntering={(e) => console.log('执行进入动画')}
                        onEntered={(e) => console.log('进入动画结束')}
                        onExit={(e) => console.log('开始离开动画')}
                        onExiting={(e) => console.log('正在离开动画')}
                        onExited={(e) => console.log('离开动画结束')}>
                        <div className=' w-full lg:w-1/3 h-screen  fixed left-0 top-0  bg-black bg-opacity-90 inout1 '>
                                   <div className=' w98 mx-auto h-2/3 overflow-auto  px-3 py-4  mt-28 bg-[#32323399] border-[1px] border-[#727477] rounded-xl'>
                                        <div className='w-full relative flex flex-row justify-center items-center text-gray-400'>
                                            <span className=' text-title-text text-base'>
                                            {t('game1.下注详情')}
                                                {/* {t('funds.参与')} */}
                                                </span>
                                            <CloseOutlined onClick={()=>setShowRecord(false)} className=' absolute right-0  text-xl' />
                                        </div>
            
                                        <div className=' w-full h-auto px-2 pt-1 pb-4 mt-5'>
                                            <div className=' w-full h-10 flex flex-row justify-between items-center '>
                                                <span className='text-gray-300   text-sm '>{t('game1.注单编号')}</span>
                                                <span className='text-gray-100   text-sm  '>{info.order_num}</span>
                                            </div>
                                            <div style={{"background-color": "rgb(226,232,240,.1)"}} className=' mx-2 h-px '></div>
                                            <div className=' w-full h-10 flex flex-row justify-between items-center '>
                                                <span className='text-gray-300   text-sm '>{t('game1.参与游戏')}</span>
                                                <span className='text-gray-100   text-sm  '>{t('game1.量子奇偶')}60S</span>
                                            </div>
                                            <div style={{"background-color": "rgb(226,232,240,.1)"}} className=' mx-2 h-px '></div>
                                            <div className=' w-full h-10 flex flex-row justify-between items-center '>
                                                <span className='text-gray-300   text-sm '>{t('game1.下注区域')}</span>
                                                <div className='flex flex-row items-center'>
                                                    <span className={`${info.petting==1?"text-red-600":"text-gray-400"} mr-2`}>{info.petting==1?t('game1.阳能'):t('game1.暗流')}</span>
                                                    {
                                                        info.petting==1?(
                                                            <img alt='rr' className='border border-text-act border-solid ' src={require('../../assets/bg/game/tbg1.jpg')} style={{"width":"12px","height":"12px"}}></img>
                                                        ):(
                                                            <img alt='rr' className='border border-text-act border-solid ' src={require('../../assets/bg/game/tbg2.jpg')} style={{"width":"12px","height":"12px"}}></img>
                                                        )
                                                    }
                                                </div>
                                                
                                                
                                            </div>
                                            <div style={{"background-color": "rgb(226,232,240,.1)"}} className=' mx-2 h-px '></div>
                                            <div className=' w-full h-10 flex flex-row justify-between items-center '>
                                                <span className='text-gray-300   text-sm '>{t('game1.中奖状况')}</span>
                                                {
                                                    info.settlement==0?(
                                                        <div className=' flex flex-row justify-end items-center text-gray-300   text-sm'>{info.state==0?t('game1.未开奖'):info.state==2?t('game1.已取消'):t('game1.退回')}</div>
                                                    ):(
                                                         <div className=' flex flex-row justify-end items-center'>
                                                            <span className='text-gray-300   text-sm mr-2'>{t('game1.结果')}</span>
                                                            {
                                                                info.petting_res==1?(
                                                                    <img alt='rr' className='border border-text-act border-solid mr-2 ' src={require('../../assets/bg/game/tbg1.jpg')} style={{"width":"12px","height":"12px"}}></img>
                                                                ):(
                                                                    <img alt='rr' className='border border-text-act border-solid mr-2 ' src={require('../../assets/bg/game/tbg2.jpg')} style={{"width":"12px","height":"12px"}}></img>
                                                                )
                                                            }
                                                            {
                                                                info.is_win==2?(
                                                                    <span className='text-green-500   text-sm'>{t('game1.中奖')}</span>
                                                                ):(
                                                                    <span className='text-red-600   text-sm'>{t('game1.未中奖')}</span>
                                                                )
                                                            }
                                                            
                                                        </div>
                                                    )
                                                }
                                               
                                            </div>
                                            <div style={{"background-color": "rgb(226,232,240,.1)"}} className=' mx-2 h-px '></div>
                                            <div className=' w-full h-10 flex flex-row justify-between items-center '>
                                                <span className='text-gray-300   text-sm '>{t('game1.下注金额')}</span>
                                                <span className='text-gray-100   text-sm  '>
                                                    <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={info.pet_token}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                allowNegative={false}
                                                fixedDecimalScale={true}
                                                decimalScale={2} /> {info.coin}
                                                </span>
                                            </div>
                                            <div style={{"background-color": "rgb(226,232,240,.1)"}} className=' mx-2 h-px '></div>
                                            <div className=' w-full h-10 flex flex-row justify-between items-center '>
                                                <span className='text-gray-300   text-sm '>{t('game1.返还金额')}</span>
                                                <span className={`${info.settlement<0?"text-red-600":info.settlement>0?"text-green-600":"text-gray-300"}   text-sm  `}>
                                                    {
                                                        info.settlement==0?(
                                                            "-"
                                                        ):(
                                                            <>
                                                            <NumberFormat
                                                            thousandsGroupStyle="thousand"
                                                            value={info.settlement}
                                                            prefix=""
                                                            decimalSeparator="."
                                                            displayType="text"
                                                            type="text"
                                                            thousandSeparator={true}
                                                            allowNegative={true}
                                                            fixedDecimalScale={true}
                                                            decimalScale={0} /> {info.coin}
                                                            </>
                                                        )
                                                    }
                                                    
                                                </span>
                                            </div>
                                            <div style={{"background-color": "rgb(226,232,240,.1)"}} className=' mx-2 h-px '></div>
                                            <div className=' w-full h-10 flex flex-row justify-between items-center '>
                                                <span className='text-gray-300   text-sm '>{t('game1.开奖区块')}</span>
                                                <span className='text-gray-100   text-sm  '>{info.block_num}</span>
                                            </div>
                                            <div style={{"background-color": "rgb(226,232,240,.1)"}} className=' mx-2 h-px '></div>
                                            <div onClick={()=>goTron(info.block_num)} className=' w-full h-10 flex flex-row justify-between items-center '>
                                                <span className='text-gray-300   text-sm '>{t('game1.区块哈希')}</span>
                                                {
                                                    info.settlement==0?(
                                                        <div className=' flex flex-row justify-end items-center'>
                                                            <span className='text-gray-100   text-sm  '>-</span>
                                                            
                                                        </div>
                                                    ):(
                                                        <div className=' flex flex-row justify-end items-center'>
                                                            <span className='text-gray-100   text-sm  '>...{
                                                            (info.hash).slice(-10)
                                                                
                                                                }</span>
                                                            <span className='text-blue-400   text-sm  ml-2'>[{t('game1.验证')}]</span>
                                                        </div>
                                                    )
                                                }
                                                
                                            </div>
                                            <div style={{"background-color": "rgb(226,232,240,.1)"}} className=' mx-2 h-px '></div>
                                            <div className=' w-full h-10 flex flex-row justify-between items-center '>
                                                <span className='text-gray-300   text-sm '>{t('game1.下注时间')}</span>
                                                <span className='text-gray-100   text-xs  '>{info.add_time}</span>
                                            </div>
                                              {
                                                info.state==0?info.settlement==0?(
                                                    <div className="w-full flex flex-row justify-center ">
                                                <div style={{"backgroundColor":"#6A4724"}} className=' w-24 h-8 mt-5  rounded-full  text-xs flex flex-row items-center justify-center'>
                                                <button onClick={()=>hui(info.id,info.state)}  className='w-24 h-8 assetbt2  text-sm text-white font-extrabold '>{t('game1.取消下注')}</button>
                                            </div>
                                            </div>
                                                ):null:null
                                            }
                                        </div>
                                    </div>
                        </div>
                        </CSSTransition>
            

    
            <div  className=" gameTbg1 w-full lg:w-1/3   pt-20 text-white flex flex-col relative z-10" >
                <img onClick={()=>window.history.back()} alt='rr' className=' absolute left-4' src={require('../../assets/img/re.png')} style={{"width":"40px"}}></img>                            
                <div className='w-full flex flex-row justify-end px-4'>
                     <div className=' w-1/3 h-6   rounded-full relative text-xs flex flex-row items-center pl-5' style={{"backgroundColor":"#FFFFFF30"}}>
                        <img alt='rr' className=' absolute -left-2' src={require('../../assets/icon/sea.png')} style={{"width":"24px"}}></img>
                        <CountUp start={0} end={udt_n} duration="1" decimals={2} />
                    </div>
                    <div className='ml-4  w-1/3 h-6   rounded-full relative text-xs flex flex-row items-center pl-5' style={{"backgroundColor":"#FFFFFF30"}}>
                        <img alt='rr' className=' absolute -left-2' src={require('../../assets/img/logo.png')} style={{"width":"24px"}}></img>
                        <CountUp start={0} end={feg_n} duration="1" decimals={2} />
                    </div>
                   
                </div>
                 <div className='w-full flex flex-row justify-end px-4 mt-5'>
                    <div className=' w-1/3 h-6   rounded-full relative text-xs flex flex-row items-center pl-5' style={{"backgroundColor":"#FFFFFF30"}}>
                        <img alt='rr' className=' absolute -left-2' src={require('../../assets/icon/usdtlogo.png')} style={{"width":"24px"}}></img>
                        <CountUp start={0} end={usdt_n} duration="1" decimals={2} />
                    </div>
                     <div className=' ml-4 w-1/3 h-6   rounded-full relative text-xs flex flex-row items-center pl-5' style={{"backgroundColor":"#FFFFFF30"}}>
                        <img alt='rr' className=' absolute -left-2' src={require('../../assets/img/fegw.png')} style={{"width":"24px"}}></img>
                        <CountUp start={0} end={fegw_n} duration="1" decimals={2} />
                    </div>
                </div>

                <div className=' w-full h-6 mx-auto mt-[40px]  pt-1 flex flex-row justify-center items-center  '>
                    <img alt='rr' className=' mr-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                    <span className=' text-sm text-text-act'>60S{t('game1.量子奇偶')}[{odds}X]</span>
                    <img alt='rr' className=' ml-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                </div>

                {/* <div className='mx-4 h-16 mt-8 px-4 gameTitle3 flex flex-row justify-between items-center relative'>
                    <span className=" text-sm text-white">{t('game1.单期限额')}</span>
                    <span className=" text-sm text-white">1-3000</span>
                </div> */}




                {/*  */}
            
                <div className=" mt-8 h-[135px] mx-4 flex flex-col items-center  bg-[#323233] border-[1px] border-[#727477] rounded-xl">
                    <div className=' mt-6 w-full flex flex-row justify-center items-center'>
                            <div className='w-1/3 flex flex-col items-center justify-center'>
                                <span className='text-sm text-gray-400'>{t('game1.上一开奖区块')}</span>
                                <span className='text-base mt-2 text-gray-100'><CountUp start={0} end={preBlock} preserveValue={true} separator="" duration="1" decimals={0} /></span>
                            </div>
                        
                            <div className='w-1/3 h-3 flex flex-col items-center justify-center'>
                                    <Progress  type="circle" percent={(60-sec)*100 / 60} format={(percent) => `${sec} `} />
                            </div>
                        
                            <div className='w-1/3 flex flex-col items-center justify-center'>
                                <span className='text-sm text-gray-400'>{t('game1.下一开奖区块')}</span>
                                <span className='text-base mt-2 text-gray-100'><CountUp start={0} end={nextBlock} preserveValue={true} separator="" duration="1" decimals={0} /></span>
                            </div>

                    </div>
                    <div className='mt-4 w-full flex flex-row justify-center items-center'>
                        {
                            sec>57?(
                                <span className='text-gray-300'>{t('game1.开奖哈希值')}：{t('game1.开奖中')}...</span>
                            ):(
                                <>
                                <span className='text-gray-300'>{t('game1.开奖哈希值')}：</span>{messages!=null?"..."+(messages.hash).slice(-10):""}
                                </>
                            )
                        }
                        
                    </div>
                    
                    
                </div>


                <div className=' w-full h-6 mx-auto mt-[10px]  pt-1 flex flex-row justify-center items-center  '>
                    <img alt='rr' className=' mr-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                    <span className=' text-sm text-text-act'>{t('game1.投注区')}</span>
                    <img alt='rr' className=' ml-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                </div>


                <div className=" mt-4 h-[394px] mx-4 px-4 flex flex-col items-center  bg-[#323233] border-[1px] border-[#727477] rounded-xl">
                    <div className=' mt-7 w-full flex flex-row justify-center items-center'>
                            <div onClick={()=>setCoin("feg")} className={` ${coin=='feg'?"text-text-act":"text-gray-400"}  w-1/4 flex flex-col items-center justify-center text-sm `}>
                                FEG
                            </div>
                             <div onClick={()=>setCoin("usdt")} className={` ${coin=='usdt'?"text-text-act":"text-gray-400"}  w-1/4 flex flex-col items-center justify-center text-sm`}>
                                USDT
                            </div>
                            <div  className={` ${coin=='fegw'?"text-text-act":"text-gray-400"}  w-1/4 flex flex-col items-center justify-center text-sm`}>
                                FEGW
                            </div>
                           
                            <div onClick={()=>setCoin("udt")} className={` ${coin=='udt'?"text-text-act":"text-gray-400"}  w-1/4 flex flex-col items-center justify-center text-sm`}>
                                UDT{t('game1.体验金')}
                            </div>
                    </div>
                    <div className=' w-full flex flex-row justify-center items-center -mt-1'>
                            <div onClick={()=>setCoin("feg")} className='text-gray-300 w-1/4 h-6 flex flex-col items-center justify-center text-sm '>
                                {
                                    coin=='feg'?(
                                        <img alt='rr' className='' src={require('../../assets/bg/game/index.png')} style={{"width":"42px"}}></img>
                                    ):null
                                }
                            </div>
                            <div onClick={()=>setCoin("usdt")} className='text-gray-300 w-1/4 h-6  flex flex-col items-center justify-center text-sm'>
                               {
                                    coin=='usdt'?(
                                        <img alt='rr' className='' src={require('../../assets/bg/game/index.png')} style={{"width":"42px"}}></img>
                                    ):null
                                }
                            </div>
                            <div  className='text-gray-300 w-1/4 h-6  flex flex-col items-center justify-center text-sm'>
                               {
                                    coin=='fegw'?(
                                        <img alt='rr' className='' src={require('../../assets/bg/game/index.png')} style={{"width":"42px"}}></img>
                                    ):null
                                }
                            </div>
                            
                            <div onClick={()=>setCoin("udt")} className='text-gray-300 w-1/4 h-6  flex flex-col items-center justify-center text-sm'>
                               {
                                    coin=='udt'?(
                                        <img alt='rr' className='' src={require('../../assets/bg/game/index.png')} style={{"width":"42px"}}></img>
                                    ):null
                                }
                            </div>
                    </div>
                    <div className='mt-5 px-2 w-full flex flex-row justify-between items-center'>
                        <div onClick={()=>setPetting(1)} className='flex flex-row justify-center items-center relative'>
                            <span className={` ${petting==1?"text-text-act":""} absolute  z-10 text-base`}>{t('game1.阳能')}</span>
                            <img  alt='rr' className={`  ${petting==1?"":"grayscale"}  border-2 border-text-act border-solid  `} src={require('../../assets/bg/game/tbg1.jpg')} style={{"width":"150px","height":"150px"}}></img>
                        </div>
                         <div onClick={()=>setPetting(2)} className='flex flex-row justify-center items-center relative'>
                            <span className={` ${petting==2?"text-text-act":""} absolute  z-10 text-base`}>{t('game1.暗流')}</span>
                            <img  alt='rr' className={`  ${petting==2?"":"grayscale"} border-2 border-text-act border-solid  `} src={require('../../assets/bg/game/tbg2.jpg')} style={{"width":"150px","height":"150px"}}></img>
                        </div>
                    </div>
                    <div className='px-2 w-full flex flex-row justify-between items-center mt-5 mb-4'>
                        {
                            coin=="feg"?(
                                <>
                                    <div onClick={()=>setNeedValue(20000)}  className={` ${needValue==20000?"bg-text-act":"bg-[#2d2e29cc]"} w-[49px] h-8 border border-gray-600  rounded-full  font10 flex flex-row items-center justify-center `}>
                                    20000
                                </div>
                                <div onClick={()=>setNeedValue(50000)}  className={` ${needValue==50000?"bg-text-act":"bg-[#2d2e29cc]"} w-[49px] h-8 border border-gray-600  rounded-full  font10 flex flex-row items-center justify-center `}>
                                    50000
                                </div>
                                <div onClick={()=>setNeedValue(100000)}  className={` ${needValue==100000?"bg-text-act":"bg-[#2d2e29cc]"} w-[49px] h-8 border border-gray-600  rounded-full  font10 flex flex-row items-center justify-center `}>
                                    100000
                                </div>
                                <div onClick={()=>setNeedValue(500000)}  className={` ${needValue==500000?"bg-text-act":"bg-[#2d2e29cc]"} w-[49px] h-8 border border-gray-600  rounded-full  font10 flex flex-row items-center justify-center `}>
                                    500000
                                </div>
                                <div onClick={()=>setNeedValue(1000000)}  className={` ${needValue==1000000?"bg-text-act":"bg-[#2d2e29cc]"} w-[49px] h-8 border border-gray-600  rounded-full  font10 flex flex-row items-center justify-center `}>
                                    1000000
                                </div>
                                </>
                            ):coin=="usdt"?(
                                <>
                                 <div onClick={()=>setNeedValue(5)}  className={` ${needValue==5?"bg-text-act":"bg-[#2d2e29cc]"} w-[49px] h-8 border border-gray-600  rounded-full  text-xs flex flex-row items-center justify-center `}>
                                    5
                                </div>
                                <div onClick={()=>setNeedValue(10)}  className={` ${needValue==10?"bg-text-act":"bg-[#2d2e29cc]"} w-[49px] h-8 border border-gray-600  rounded-full  text-xs flex flex-row items-center justify-center `}>
                                    10
                                </div>
                                <div onClick={()=>setNeedValue(50)}  className={` ${needValue==50?"bg-text-act":"bg-[#2d2e29cc]"} w-[49px] h-8 border border-gray-600  rounded-full  text-xs flex flex-row items-center justify-center `}>
                                    50
                                </div>
                                <div onClick={()=>setNeedValue(100)}  className={` ${needValue==100?"bg-text-act":"bg-[#2d2e29cc]"} w-[49px] h-8 border border-gray-600  rounded-full  text-xs flex flex-row items-center justify-center `}>
                                    100
                                </div>
                                <div onClick={()=>setNeedValue(200)}  className={` ${needValue==200?"bg-text-act":"bg-[#2d2e29cc]"} w-[49px] h-8 border border-gray-600  rounded-full  text-xs flex flex-row items-center justify-center `}>
                                    200
                                </div>
                                </>
                            ):(
                                <>
                                    <div onClick={()=>setNeedValue(5)}  className={` ${needValue==5?"bg-text-act":"bg-[#2d2e29cc]"} w-[49px] h-8 border border-gray-600  rounded-full  text-xs flex flex-row items-center justify-center `}>
                                    5
                                </div>
                                <div onClick={()=>setNeedValue(10)}  className={` ${needValue==10?"bg-text-act":"bg-[#2d2e29cc]"} w-[49px] h-8 border border-gray-600  rounded-full  text-xs flex flex-row items-center justify-center `}>
                                    10
                                </div>
                                <div onClick={()=>setNeedValue(50)}  className={` ${needValue==50?"bg-text-act":"bg-[#2d2e29cc]"} w-[49px] h-8 border border-gray-600  rounded-full  text-xs flex flex-row items-center justify-center `}>
                                    50
                                </div>
                                <div onClick={()=>setNeedValue(100)}  className={` ${needValue==100?"bg-text-act":"bg-[#2d2e29cc]"} w-[49px] h-8 border border-gray-600  rounded-full  text-xs flex flex-row items-center justify-center `}>
                                    100
                                </div>
                                <div onClick={()=>setNeedValue(200)}  className={` ${needValue==200?"bg-text-act":"bg-[#2d2e29cc]"} w-[49px] h-8 border border-gray-600  rounded-full  text-xs flex flex-row items-center justify-center `}>
                                    200
                                </div>
                                </>
                            )
                        }
                    </div>

                    <div className='px-2 w-full flex flex-row justify-between items-center mt-2'>
                        <div  className=' w-[168px] h-8   border border-gray-600  rounded-full  text-xs flex flex-row items-center justify-center'>
                            <input  onInput={(e)=>setNeedValue(e.target.value)} value={needValue} placeholder={t('game1.输入数量')} type="number"   className=' w-4/5 h-9 text-sm text-white input1 ' ></input>
                        </div>
                        <div style={{"backgroundColor":"#eab308"}} className=' w-24 h-8   rounded-full  text-xs flex flex-row items-center justify-center'>
                            <button onClick={open}  className='w-24 h-8   text-sm text-white font-extrabold '>{t('game1.确定下注')}</button>
                        </div>
                       
                    </div>
                    
                    
                </div>

                <div className=' w-full h-6 mx-auto mt-[40px]  pt-1 flex flex-row justify-center items-center  '>
                    <img alt='rr' className=' mr-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                    <span className=' text-sm text-text-act'>{t('game1.开奖走势')}</span>
                    <img alt='rr' className=' ml-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                </div>

                <div className=" mt-8 h-[195px] px-4 pt-4 mx-4 flex flex-col items-center  bg-[#323233] border-[1px] border-[#727477] rounded-xl">
                    <div className=' w-full flex flex-row h-8 items-center justify-center'>
                        <div class='w-4 h-4  bg-red-500  text-xs'></div>
                        <span className='ml-1'>{t('game1.阳能')}</span>
                        {/* <span>2</span> */}
                        <div class='w-4 h-4 ml-3 bg-gray-500  text-xs'></div>
                        <span className='ml-1'>{t('game1.暗流')}</span>
                        {/* <span>2</span> */}
                    </div>
                    {
                        qu!=null?(
                            <div dangerouslySetInnerHTML={{ __html: qu }} ref={scrollContainerRef} className=" w-full px-1 h-[125px]  flex flex-row overflow-x-auto">
                                      
                        
                    </div>
                        ):(
                            <div  className=" w-full px-1 h-[125px]  flex flex-row overflow-x-auto justify-center items-center text-gray-400">
                                      
                            {t('game1.同步中')}...
                    </div>
                        )
                    }
                    
                </div>

                <div className=' w-full h-6 mx-auto mt-[40px]  pt-1  flex flex-row justify-center items-center  '>
                    <img alt='rr' className=' mr-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                    <span className=' text-sm text-text-act'>{t('game1.下单记录')}</span>
                    <img alt='rr' className=' ml-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                </div>

                <div className="w-full mt-8  px-4  flex flex-col items-center">
                    <div className='w-full px-4 pt-1 h-[57px] mt-6  flex flex-row justify-center items-center  bg-[#323233] border-[1px] border-[#727477] border-b-0 rounded-t-xl'>
                        <div className='w-1/2 h-6 flex flex-row justify-start items-center text-xs text-gray-400'>
                            <span>{t('game1.币种')}</span>
                             <span className=' ml-4'>{t('game1.数量')}</span>
                        </div>
                        <div className="w-1/2 h-6 flex flex-row justify-end items-center text-xs text-gray-400">
                            <span>{t('game1.输赢结果')}</span>
                        </div>
                    </div>

                    <div className='w-full min-h-[500px] px-4 flex flex-col justify-start items-start text-sm text-gray-100 bg-[#323233] border-[1px] border-[#727477] border-t-0 border-b-0 '>
                        {
                            list.length>0?
                            list.map((item,index)=>{
                                return(
                                    <div className='w-full' key={item.id} onClick={()=>_showRecord(item)}>
                                        <div className='w-full flex flex-row justify-start items-center'>
                                            <div className=' w-1/2 flex flex-col justify-item items-start'>
                                                <div><span className='text-xs text-gray-100'>{item.block_num}</span></div>
                                                
                                                <div className='w-full mt-2 flex flex-row justify-start items-center text-xs text-gray-100'>
                                                    <span className='mr-2'>{t('game1.投')}</span>
                                                    <span className={`${item.petting==1?"text-red-600":"text-gray-400"} mr-2`}>{item.petting==1?t('game1.阳能'):t('game1.暗流')}</span>
                                                    {
                                                        item.petting==1?(
                                                             <img alt='rr' className='border border-text-act border-solid mr-2' src={require('../../assets/bg/game/tbg1.jpg')} style={{"width":"12px","height":"12px"}}></img>
                                                        ):(
                                                             <img alt='rr' className='border border-text-act border-solid mr-2' src={require('../../assets/bg/game/tbg2.jpg')} style={{"width":"12px","height":"12px"}}></img>
                                                        )
                                                    }
                                                   
                                                    <span className='text-text-act'>
                                                        <NumberFormat
                                                                thousandsGroupStyle="thousand"
                                                                value={item.pet_token}
                                                                prefix=""
                                                                decimalSeparator="."
                                                                displayType="text"
                                                                type="text"
                                                                thousandSeparator={true}
                                                                allowNegative={false}
                                                                fixedDecimalScale={true}
                                                                decimalScale={2} /> {item.coin}
                                                    </span>
                                                    
                                                </div>
                                            </div>
                                            <div className='w-1/2 flex flex-row justify-center items-center '>
                                                <div className=' w-10/12 flex flex-col '>
                                                    <div className='w-full  flex flex-row justify-end items-center text-xs text-gray-100'>
                                                        {
                                                            item.petting_res ==0?(
                                                                <span className='mr-2'>{info.state==0?t('game1.未开奖'):info.state==2?t('game1.已取消'):t('game1.退回')}</span>
                                                            ):(
                                                                <>
                                                                    <span className='mr-2'>{t('game1.结果')}</span>
                                                                    {
                                                                        item.petting_res==1?(
                                                                            <img alt='rr' className='border border-text-act border-solid mr-2' src={require('../../assets/bg/game/tbg1.jpg')} style={{"width":"12px","height":"12px"}}></img>
                                                                        ):(
                                                                            <img alt='rr' className='border border-text-act border-solid mr-2' src={require('../../assets/bg/game/tbg2.jpg')} style={{"width":"12px","height":"12px"}}></img>
                                                                        )
                                                                    }
                                                                    
                                                                    <span className={`${item.settlement>0?"text-green-400":item.settlement<0?"text-red-500":"text-gray-300"}`}>
                                                                        <NumberFormat
                                                                                thousandsGroupStyle="thousand"
                                                                                value={item.settlement}
                                                                                prefix=""
                                                                                decimalSeparator="."
                                                                                displayType="text"
                                                                                type="text"
                                                                                thousandSeparator={true}
                                                                                allowNegative={true}
                                                                                fixedDecimalScale={true}
                                                                                decimalScale={2} />
                                                                    </span>
                                                                </>
                                                            )
                                                        }
                                                        
                                                    </div>
                                                    <span className='text-xs text-gray-300 mt-2 text-right'>{item.add_time}</span>
                                                    
                                                </div>
                                                <div className='ml-1 w-1/12 text-lg flex flex-row justify-end  text-amber-800'>{">"}</div>
                                            </div>
                                            
                                        </div>

                                        
                                        <div className='w-full h-px my-2' style={{"backgroundColor":"#FF7D0030"}}></div>
                                    </div>
                                    
                                )
                            }):(
                                
                                <div  className=' w-full h-28 py-3 mt-5 flex flex-row items-center justify-center text-gray-600 text-xs'>
                                        No data
                                </div>
                            )
                        }


                    </div>


                   <div className='w-full px-4 pt-0 h-[57px]   flex flex-row justify-center items-center  bg-[#323233] border-[1px] border-[#727477] border-t-0 rounded-b-xl'>
                        
                    </div>
                   
                    
                     <div className=' w-full mt-[60px] font10 text-gray-300 flex flex-row justify-center items-center'>
                     CopyRight@ FEG Golden Federal Reserve 2025
                </div>
                

                </div>

      

               
    

            </div>
            <div className=' w-full h-[684px] fixed bottom-0 gameTbg11 z-0'>

                </div>


         
        </>
    );
}

export default connect(mapStateToProps)(Game160);
